import { useEffect } from "react";

import { VictoryChart } from "victory";

import type { VictoryChartCanvasProps } from "@/crossPlatform/victory/types";

// on web, the `victory` package renders a single <svg>, that no longer needs a Svg or Defs wrapper
// if `victory-native` were used on web, it would work, but pass native-only props that trigger unnecessary console warnings/errors
const VictoryChartCanvas = ({
  children,
  domainPadding,
  gradient,
  height,
  onReady,
  padding,
  style,
}: VictoryChartCanvasProps) => {
  // on web there is no width measurement to wait on, so the chart is ready on mount
  useEffect(() => {
    onReady();
  }, [onReady]);

  return (
    <>
      <svg height={0} width={0}>
        <defs>
          <linearGradient id={gradient.id} x1="0%" x2="100%" y1="0%" y2="0%">
            <stop offset="0%" stopColor={gradient.startColor} />
            <stop offset="100%" stopColor={gradient.endColor} />
          </linearGradient>
        </defs>
      </svg>
      <VictoryChart
        domainPadding={domainPadding}
        height={height}
        padding={padding}
        style={style}
      >
        {children}
      </VictoryChart>
    </>
  );
};

export {
  VictoryAxis,
  VictoryLabel,
  VictoryLine,
  VictoryScatter,
} from "victory";
export { VictoryChartCanvas };
